import { Observable } from 'rxjs/Observable'

import { JsonApiProcessor } from '../operation/operation-processors'
import { OperationServiceAdapter } from '../'
import { Upload } from '../../models'

export class UploadService extends OperationServiceAdapter<Upload> {

  public constructor(
    _operationProcessor: JsonApiProcessor
  ) {
    super(_operationProcessor, Upload)
  }

  public create(upload: Upload, includes?: string[], filters?: {}): Observable<Upload> {
    const params = this._createParams(upload)
    return this.callPostOperation('create', params, includes, filters) as Observable<Upload>
  }

  private _createParams(upload: Upload) {
    return {
      upload: {
        category: upload.category,
        locationUrl: upload.locationUrl,
        content: upload.content
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/upload/upload.service.ts